import Vue from 'vue'
import Vuex from 'vuex'
import languageStore from './languageStore'

Vue.use(Vuex)

export default new Vuex.Store({
  modules:{
    languageStore
  }
})



// WEBPACK FOOTER //
// ./src/store/index.js